import { MobilityOption, CreateMobilityOptionRequest, UpdateMobilityOptionRequest } from "@/models/mobility-option";
import { assertTokenValidForMutation, handleResponse } from "@/services/service-helpers";
import log from '@/lib/logger';

const NBH_MOBILITY_OPTIONS_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/mobility-options`;
const NBH_MOBILITY_OPTIONS_ADMIN_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/mobility-options`;

export async function fetchAllMobilityOptions(token: string | null): Promise<MobilityOption[] | void> {
    if (!token) {
        log.error("No token provided. Cannot fetch mobility options.");
        return Promise.reject("No token provided.");
    }

    const response = await fetch(`${NBH_MOBILITY_OPTIONS_BASE_URL}`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

    return handleResponse<MobilityOption[]>(response);
}

export async function createMobilityOption(
    token: string | null,
    request: CreateMobilityOptionRequest
): Promise<MobilityOption | void> {
    if (!token) {
        log.error("No token provided. Cannot create mobility option.");
        return Promise.reject("No token provided.");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_MOBILITY_OPTIONS_ADMIN_BASE_URL}`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    });

    return handleResponse<MobilityOption>(response);
}

export async function updateMobilityOption(
    token: string | null,
    id: string,
    request: UpdateMobilityOptionRequest
): Promise<MobilityOption | void> {
    if (!token) {
        log.error("No token provided. Cannot update mobility option.");
        return Promise.reject("No token provided.");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_MOBILITY_OPTIONS_ADMIN_BASE_URL}/${id}`, {
        method: "PATCH",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    });

    return handleResponse<MobilityOption>(response);
}

export async function deleteMobilityOption(token: string | null, id: string): Promise<void> {
    if (!token) {
        log.error("No token provided. Cannot delete mobility option.");
        return Promise.reject("No token provided.");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_MOBILITY_OPTIONS_ADMIN_BASE_URL}/${id}`, {
        method: "DELETE",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

    return handleResponse<void>(response);
}
